import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { DataStore } from '../stores';
import InfiniteScroll from 'react-infinite-scroller';

export interface ScrollWrapperProps {
    dataStore?: DataStore;
}

// Higher-order component to return a FundCard with data and methods required to function
const withInfiniteScroll = WrappedComponent => {
    @inject('dataStore')
    @observer
    class ScrollWrapper extends Component<ScrollWrapperProps, any> {
        @computed
        get config() {
            return this.props.dataStore.config;
        }

        @computed
        get pagingConfig() {
            return this.config.paging;
        }

        @computed
        get hasInfiniteScroll() {
            const pagingConfig = this.pagingConfig;
            return !!pagingConfig && pagingConfig.mode === 'infiniteScroll';
        }

        render() {
            const { dataStore } = this.props;
            if (this.hasInfiniteScroll) {
                const infiniteScrollProps =
                    this.pagingConfig.infiniteScrollOptions || {};
                return (
                    <InfiniteScroll
                        pageStart={0}
                        initialLoad={false}
                        threshold={250}
                        loadMore={() => dataStore.getFunds(true)}
                        hasMore={!dataStore.hasAllFunds}
                        {...infiniteScrollProps}
                    >
                        <WrappedComponent {...this.props} />
                    </InfiniteScroll>
                );
            }
            return <WrappedComponent {...this.props} />;
        }
    }

    return ScrollWrapper;
};

export default withInfiniteScroll;



// WEBPACK FOOTER //
// ./src/Components/withInfiniteScroll.tsx